import { PussInBootsPageProps } from 'src/features/PussInBoots/types/pussInBootsPageProps';
import Learn from './LearnCommunicate/Learn';
import Communicate from './LearnCommunicate/Communicate';
import Jumbotron from './Jumbotron';
import MarketingMessage from './MarketingMessage';
import LearnImmerseCommunicate from './LearnImmerseCommunicate';

type Props = Pick<
  PussInBootsPageProps,
  'cinema1' | 'cinema2' | 'ticketsLink' | 'trailer1' | 'trailer2'
>;

export const PussInBootsPageContent = ({
  cinema1,
  cinema2,
  ticketsLink,
  trailer1,
  trailer2,
}: Props) => {
  return (
    <>
      <Jumbotron />
      <LearnImmerseCommunicate cinema1={cinema1} ticketsLink={ticketsLink} trailer1={trailer1} />
      <Learn scenario={trailer2} />
      <Communicate scenario={cinema2} />
      <MarketingMessage />
    </>
  );
};
